import {getObjectWithLowerCaseKeys} from '../utils/objectUtils';

export class Notification {
  /**
   * @param {date} timestamp
   * @param {string} userId
   * @param {string} type
   * @param {string} area
   * @param {string} message
   * @param {string} title
   * @param {string} url
   * @param {date} readAt
   * @param {string} jobId
   * @param {string} jobType
   * @param {boolean} triggerDownload
   */
  constructor(
      timestamp = undefined,
      userId = undefined,
      type = undefined,
      area = undefined,
      message = undefined,
      title = undefined,
      url = undefined,
      readAt = undefined,
      jobId = undefined,
      jobType = undefined,
      triggerDownload = false,
  ) {
    this.timestamp = timestamp;
    this.userId = userId;
    this.type = type;
    this.area = area;
    this.message = message;
    this.title = title;
    this.url = url;
    this.readAt = readAt;
    this.jobId = jobId;
    this.jobType = jobType;
    this.triggerDownload = triggerDownload;
  }


  static from(obj) {
    const notification = Object.assign(new Notification(), getObjectWithLowerCaseKeys(obj));
    notification.jobType = obj.Job?.Type;
    return notification;
  }
}